<template>
  <div class="speeddial-holder">
    <div class="speeddial-btn speeddial-btn__parent" @click="click">
      <div class="morph-icon">
        <div class="morph-bar morph-bar__top"></div>
        <div class="morph-bar morph-bar__bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   methods: {
     click() {
       this.$emit('next-step', this.$store.state.rotator.activeType + 1 || 0);
     }
   }
 }
</script>



// WEBPACK FOOTER //
// NextStepButton.vue?e3184c24